import React, { useEffect, useState } from 'react';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import AppRoutes from './routes';
import { Alert, Container, Spinner } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

function App() {
  const [appReady, setAppReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        console.log('🚀 Inicializando aplicação...');
        
        // Verificar variáveis de ambiente
        if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
          console.warn('⚠️ Variáveis de ambiente do Supabase não encontradas');
          setError('Configuração do Supabase não encontrada. Verifique o arquivo .env');
        }
        
        // Aguardar um pouco para UI estabilizar
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        console.log('✅ Aplicação inicializada');
        
      } catch (error) {
        console.error('❌ Erro na inicialização:', error);
        setError('Erro na inicialização: ' + error.message);
      } finally {
        setAppReady(true);
        // Remover tela de loading do HTML
        document.body.classList.add('loaded');
      }
    };

    initializeApp();
  }, []);

  // Loading inicial mais simples
  if (!appReady) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Container className="text-center">
          <div className="mb-3">
            <img 
              src="/logo-mm-eventos.png" 
              alt="MM Eventos" 
              style={{ maxHeight: '80px', opacity: 0.9 }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-primary fw-bold">Inicializando Sistema</p>
          <small className="text-muted">
            Carregando configurações...
            <br />
            MM Eventos® Health Division
          </small>
        </Container>
      </div>
    );
  }

  return (
    <HashRouter>
      <AuthProvider>
        {/* Mostrar erro de configuração se houver */}
        {error && (
          <Alert variant="danger" className="m-0 text-center">
            <strong>⚠️ Erro de Configuração:</strong> {error}
            <br />
            <small>Verifique as configurações do Supabase no arquivo .env</small>
          </Alert>
        )}
        
        <AppRoutes />
      </AuthProvider>
    </HashRouter>
  );
}

export default App;

